<template>
  <div id="listen">
    <vue-confirm-dialog></vue-confirm-dialog>
    <v-app>
      <AppBar />
      <v-main> <router-view :key="$route.fullPath" /> </v-main>
      <FloatingIcon />
      <FloatingIcon2 />
      <Footer />
      <SnackBar />
    </v-app>
  </div>
</template>

<script>
import FloatingIcon from "./components/FloatingIcon";
import FloatingIcon2 from "./components/FloatingIcon2";
import AppBar from "./components/AppBar";
import Footer from "./components/Footer";
import SnackBar from "./components/SnackBar";

export default {
  name: "App",
  components: {
    FloatingIcon,
    FloatingIcon2,
    Footer,
    AppBar,
    SnackBar,
  },
};
</script>
